import React from 'react';
import { View as OriginalView, Text as OriginalText, StyleSheet, Image as OriginalImage} from '@react-pdf/renderer'
import {useServer} from "./Hooks/ServerContext";

const styles = StyleSheet.create({
    text: {

        fontSize: 14,
        textAlign: 'justify',

    },

});
const pa = 500;
const Text = ({style,...props}) => <OriginalText  style={{...styles.text,...style}} minPresenceAhead={pa} {...props} />;
const Image = ({src,...props}) => {
    const server = useServer();
    const newsrc = server ? 'public'+src:src;
   return <OriginalImage allowDangerousPaths minPresenceAhead={pa} src={newsrc}{...props}/>;
}
const NonServerImage = ({ src, ...props }) => <OriginalImage allowDangerousPaths minPresenceAhead={pa} src={src}{...props} />;

const View = (props) => <OriginalView {...props}/>;

export { Text, Image, View, StyleSheet, NonServerImage };